(function () {
  'use strict';

  var STORAGE_KEY = 'belnay:recently-viewed';
  var MAX_STORED = 8;
  var HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;
  var DEBOUNCE_MS = 250;
  var MIN_QUERY = 2;

  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;

  var panel = modal.querySelector('[data-search-panel]');
  var input = modal.querySelector('[data-search-input]');
  var results = modal.querySelector('[data-search-results]');
  var recent = modal.querySelector('[data-search-recent]');
  var recentGrid = modal.querySelector('[data-search-recent-grid]');
  var clearButton = modal.querySelector('[data-search-clear-recent]');

  var predictiveUrl = modal.getAttribute('data-predictive-url') || '/search/suggest';
  var rootUrl = modal.getAttribute('data-root-url') || '/';
  var limit = parseInt(modal.getAttribute('data-limit'), 10) || 4;
  var defaultsUrl = modal.getAttribute('data-defaults-url');
  var defaultResults = results ? results.innerHTML : '';
  var defaultsRequest = null;

  var lastFocus = null;
  var debounceTimer = null;
  var controller = null;
  var recentLoaded = false;
  var pendingRecent = null;

  function readHandles() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (handle) {
          return typeof handle === 'string' && HANDLE_PATTERN.test(handle);
        })
        .slice(0, MAX_STORED);
    } catch (e) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage disabled or full — recently viewed is optional */
    }
  }

  function recordCurrentProduct() {
    var handle = modal.getAttribute('data-current-handle');
    if (!handle || !HANDLE_PATTERN.test(handle)) return;
    var handles = readHandles().filter(function (stored) {
      return stored !== handle;
    });
    handles.unshift(handle);
    writeHandles(handles.slice(0, MAX_STORED));
  }

  function sectionUrl(handle) {
    var base = rootUrl === '/' ? '' : rootUrl.replace(/\/$/, '');
    return base + '/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed';
  }

  function fetchText(url, options) {
    return fetch(url, options).then(function (response) {
      return response.ok ? response.text() : '';
    });
  }

  function firstCard(html) {
    if (!html) return null;
    var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.search-card');
    return card ? document.importNode(card, true) : null;
  }

  function loadRecent() {
    if (!recent || !recentGrid || recentLoaded) return;
    var handles = readHandles().slice(0, limit);
    if (!handles.length) return;
    recentLoaded = true;

    Promise.all(
      handles.map(function (handle) {
        return fetchText(sectionUrl(handle)).catch(function () {
          return '';
        });
      })
    ).then(function (chunks) {
      var fragment = document.createDocumentFragment();
      chunks.forEach(function (html) {
        var card = firstCard(html);
        if (card) fragment.appendChild(card);
      });
      pendingRecent = null;
      if (!fragment.childNodes.length) {
        if (recent) recent.hidden = true;
        pruneResults(results);
        return;
      }
      recentGrid.innerHTML = '';
      recentGrid.appendChild(fragment);
      showRecent();
      pruneResults(results);
    });
  }

  /* Typing a query: results go to the top and recently viewed steps aside,
     so it does not look as if the search did nothing (owner, 27 Oct 2026). */
  function searching() {
    return !!input && input.value.trim().length >= MIN_QUERY;
  }

  function showRecent() {
    if (!recent) return;
    recent.hidden = searching() || !(recentGrid && recentGrid.querySelector('[data-product-handle]'));
  }

  function skipSet() {
    var set = {};
    if (searching()) return set;
    var cards = recentGrid ? recentGrid.querySelectorAll('[data-product-handle]') : [];
    if (cards.length) {
      Array.prototype.forEach.call(cards, function (card) {
        var handle = card.getAttribute('data-product-handle');
        if (handle) set[handle] = true;
      });
      return set;
    }
    if (pendingRecent) {
      pendingRecent.forEach(function (handle) {
        set[handle] = true;
      });
    }
    return set;
  }

  /* Recently viewed already shows these pieces, so the products grid
     skips them and fills the open slots from the extra cards. */
  function pruneResults(root) {
    if (!root) return;
    var grid = root.querySelector('.search-modal__grid');
    var label = root.querySelector('.search-modal__label');
    if (!grid) return;
    var skip = skipSet();
    var seen = {};
    var kept = 0;
    Array.prototype.forEach.call(grid.querySelectorAll('.search-card'), function (card) {
      var handle = card.getAttribute('data-product-handle') || '';
      if ((handle && (skip[handle] || seen[handle])) || kept >= limit) {
        card.hidden = true;
        return;
      }
      if (handle) seen[handle] = true;
      card.hidden = false;
      kept += 1;
    });
    var show = kept > 0;
    if (label) label.hidden = !show;
    grid.hidden = !show;
  }

  function isPhone() {
    return window.matchMedia('(max-width: 899px)').matches;
  }

  /* On the phone the field stays unread until the shopper taps it.
     Focusing it on open is what raises the keyboard and shifts the bar. */
  function holdField() {
    if (!input) return;
    input.readOnly = true;
    if (document.activeElement === input) input.blur();
  }

  function placeUnderHeader() {
    if (!isPhone()) {
      modal.style.removeProperty('--search-modal-top');
      return;
    }
    var header = document.querySelector('[data-header]');
    var bottom = header ? Math.round(header.getBoundingClientRect().bottom) : 58;
    modal.style.setProperty('--search-modal-top', bottom + 'px');
  }

  function clearRecent() {
    writeHandles([]);
    pendingRecent = null;
    if (recentGrid) recentGrid.innerHTML = '';
    if (recent) recent.hidden = true;
    recentLoaded = true;
    pruneResults(results);
    if (!input) return;
    input.readOnly = false;
    input.focus({ preventScroll: true });
  }

  /* The popular pieces are not in the page HTML. The section renders them for
     the search template; fetch that once, on first open. */
  function loadDefaults() {
    if (!results || !defaultsUrl || defaultResults.trim() || defaultsRequest) return;
    defaultsRequest = fetchText(defaultsUrl)
      .then(function (html) {
        var box = html
          ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-results]')
          : null;
        if (!box) return;
        defaultResults = box.innerHTML;
        if (!input || input.value.trim().length < MIN_QUERY) showDefaultResults();
      })
      .catch(function () {
        defaultsRequest = null;
      });
  }

  function showDefaultResults() {
    if (!results) return;
    results.innerHTML = defaultResults;
    results.removeAttribute('aria-busy');
    pruneResults(results);
  }

  function runSearch(term) {
    if (!results) return;
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var url =
      predictiveUrl +
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=' +
      Math.min(10, limit * 2) +
      '&section_id=predictive-search';

    results.setAttribute('aria-busy', 'true');

    fetchText(url, controller ? { signal: controller.signal } : undefined)
      .then(function (html) {
        var section = html
          ? new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('#shopify-section-predictive-search')
          : null;
        if (section) results.innerHTML = section.innerHTML;
        results.removeAttribute('aria-busy');
        pruneResults(results);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        results.removeAttribute('aria-busy');
      });
  }

  function onInput() {
    var term = input.value.trim();
    window.clearTimeout(debounceTimer);
    showRecent();

    if (term.length < MIN_QUERY) {
      if (controller) controller.abort();
      showDefaultResults();
      return;
    }

    debounceTimer = window.setTimeout(function () {
      runSearch(term);
    }, DEBOUNCE_MS);
  }

  function setTriggerState(expanded) {
    var triggers = document.querySelectorAll('[data-search-open]');
    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.setAttribute('aria-expanded', expanded);
    });
  }

  function focusable() {
    if (!panel) return [];
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(panel.querySelectorAll(selector), function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    });
  }

  function trapFocus(event) {
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function isOpen() {
    return modal.classList.contains('is-open');
  }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    if (window.Belnay && typeof window.Belnay.lockPageScroll === 'function') {
      window.Belnay.lockPageScroll('search');
    }
    var hasRecentCards = !!(recentGrid && recentGrid.querySelector('[data-product-handle]'));
    pendingRecent = hasRecentCards ? null : readHandles().slice(0, limit);
    pruneResults(results);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-modal-open');
    setTriggerState('true');
    loadDefaults();
    loadRecent();
    if (isPhone()) {
      placeUnderHeader();
      holdField();
      if (document.activeElement && document.activeElement !== document.body && document.activeElement.blur) {
        document.activeElement.blur();
      }
    } else if (input) {
      input.readOnly = false;
      input.focus({ preventScroll: true });
      input.select();
    }
  }

  function close() {
    if (!isOpen()) return;
    window.clearTimeout(debounceTimer);
    var phone = isPhone();
    /* readOnly is cleared only after a tap. Blur and unpin in the same
       turn races the keyboard, so wait until the viewport settles. */
    var fieldEngaged = !!(phone && input && input.readOnly === false);
    if (input) {
      if (phone) input.readOnly = true;
      input.blur();
    }
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-modal-open');
    modal.style.removeProperty('--search-modal-top');
    if (fieldEngaged && window.Belnay && typeof window.Belnay.unlockPageScrollWhenSettled === 'function') {
      window.Belnay.unlockPageScrollWhenSettled('search');
    } else if (window.Belnay && typeof window.Belnay.unlockPageScroll === 'function') {
      window.Belnay.unlockPageScroll('search');
    }
    setTriggerState('false');
    if (!phone && lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var trigger = event.target.closest('[data-search-open]');
    if (trigger) {
      event.preventDefault();
      if (isOpen()) close();
      else open();
      return;
    }
    if (isOpen() && event.target.closest('[data-search-close]')) {
      event.preventDefault();
      close();
      return;
    }
    // Two stacked overlays read as broken, so yield to the cart drawer.
    if (isOpen() && event.target.closest('[data-cart-drawer-open]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key === 'Tab') trapFocus(event);
  });

  if (input) {
    input.addEventListener('pointerdown', function () {
      if (!isPhone() || !isOpen()) return;
      input.readOnly = false;
    });
    input.addEventListener('input', onInput);
  }
  if (clearButton) clearButton.addEventListener('click', clearRecent);

  recordCurrentProduct();

  window.BelnaySearch = { open: open, close: close, place: placeUnderHeader };
})();
